module.exports = __webpack_public_path__ + "img/TV_clean_box27.48805ab9.jpg";